/**
 * Split ERP shop categories by tree path: Product Category vs Laboratory Type (under Webshop).
 * Matches mega-menu logic — keep in sync when changing rules.
 */
export function partitionShopCategories<T extends { path?: string }>(categories: T[]): {
  productCategories: T[];
  laboratoryTypes: T[];
} {
  if (!categories?.length) {
    return { productCategories: [], laboratoryTypes: [] };
  }

  const laboratoryTypes = categories.filter((cat) => {
    const pathLower = cat.path?.toLowerCase() || '';
    return pathLower.includes('laboratory type');
  });

  const productCategories = categories.filter((cat) => {
    const pathLower = cat.path?.toLowerCase() || '';
    return pathLower.includes('product category') && !pathLower.includes('laboratory type');
  });

  return { productCategories, laboratoryTypes };
}

/** First product category, else first lab type, else first row (unpartitioned edge case). */
export function getDefaultShopCategorySelection<T extends { path?: string }>(categories: T[]): T | undefined {
  const { productCategories, laboratoryTypes } = partitionShopCategories(categories);
  return productCategories[0] ?? laboratoryTypes[0] ?? categories[0];
}
